
// 用来控制按钮的显示
export function hasBtnPermission(permission) {
  console.log(permission);
  return true;

}
